import { fromJS } from 'immutable'
import {
  MY_TIMESHEET_SET_INVALID_INPUT,
  MY_TIMESHEET_RESET_INVALID_INPUT,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  invalidList: [],
})

export default (state = init, action) => {
  switch (action.type) {
    case MY_TIMESHEET_SET_INVALID_INPUT:
      return state
        .set('invalidList', action.payload)
    case MY_TIMESHEET_RESET_INVALID_INPUT:
      return state
        .set('invalidList', [])
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/my-timesheet-set-invalid-input-reducer.js